import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { filterShownValues } from "./shown-values-filter";
import { sortData } from "./sorter";
import { convertToValidCssClass } from "common/string-helper";
import { ShownValuesTypes } from "components/widgets/chart/base/chart-settings/types";
import { SortByTypes } from "store/current-dashboard/types";
export const defaultMapper = {
    [SortByTypes.Name]: (o) => o.name,
    [SortByTypes.Value]: (o) => o.y || 0
};
export const applyUserSettings = (data, userSettings, isEsgData, esgClassName, addOther, valueSelectors = defaultMapper) => {
    if (!data) {
        return data;
    }
    let returnData = sortData(data, userSettings.sortBy || SortByTypes.Value, isEsgData, valueSelectors);
    if (userSettings.shownValues?.filter &&
        userSettings.shownValues.filter !== ShownValuesTypes.All &&
        userSettings.sortBy !== SortByTypes.Name) {
        returnData = filterShownValues(returnData, userSettings.shownValues, valueSelectors[SortByTypes.Value], addOther);
    }
    if (returnData && isEsgData && esgClassName) {
        returnData = returnData
            .map((val) => ({ ...val, className: convertToValidCssClass(`${esgClassName}-${val.name}`) }));
    }
    return returnData;
};
export const useRefreshOnUserSettingsChange = () => useSelector((state) => state.settings.current, isEqual);
